module.exports = __webpack_public_path__ + "img/linkedin.8eba6900.png";